import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const UnlockOutline = createIcon({
  displayName: 'UnlockOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="2" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M17 21h-10c-1.105 0-2-.895-2-2v-7c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2v7c0 1.105-.895 2-2 2Z"></path>
        <path d="M16 7c0-2.209-1.791-4-4-4 -1.87 0-3.428 1.289-3.866 3.023"></path>
        <path d="M16 10v-3"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const Unlock: FC<IconProps> = (props) => {
  return <CustomIcon as={UnlockOutline} {...props} />
}

export default memo(Unlock)
